module.exports = __webpack_public_path__ + "images/sales_contact_suggestion/wada@2x_ea8322949445a89f9090d7d56242a586.png";